import type { FilterSelection } from '@amzn/stencil-react-components/filtering';

export type FilterChangeValue = FilterSelection;

/** Normalizes Stencil filter scalar, array, and empty selections to string arrays. */
export function toFilterStringArray(value: FilterChangeValue): string[] {
  if (Array.isArray(value)) return value.map(String);
  if (typeof value === 'string' || typeof value === 'number') {
    return [String(value)];
  }
  return [];
}
